// Requester contact (name / email / phone) captured at the pre-preview step and
// reused to prefill checkout on the same device.
//
// Stored client-side ONLY. The server also persists this on the Story for lead
// capture (see server/routes/stories.js /create), but the public, shareable
// GET /api/stories/preview/:shareToken deliberately does NOT return it — so a
// shared preview link never exposes the requester's email/phone. localStorage
// covers the real flow (contact → preview → checkout in the same browser); a
// different device simply gets no prefill, which is the safe failure.
const KEY = 'anabatal_lead_contact';

export function saveLeadContact(contact) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      name:  contact?.name || '',
      email: contact?.email || '',
      phone: contact?.phone || '',
    }));
  } catch {
    // Private mode / quota / disabled storage — prefill is best-effort.
  }
}

export function loadLeadContact() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
